import React from 'react';
import BuscaForm from '../../gww-lib/busca-no-form/index';

export default function DadosNota(props) {
    const {
        cliente,
        setCliente,
        clienteErro,
        clienteErroTexto,
        descricaoCliente,
        setDescricaoCliente,
        cfop,
        setCfop,
        cfopErro,
        cfopErroTexto,
        descricaoCfop,
        setDescricaoCfop,
        inativo
    } = props;
    return (
        <>
            <BuscaForm
                codigo={cliente}
                tabela="PESSOA"
                label="Cliente"
                consultaInstantanea
                setCodigoPai={(cliente) => setCliente(cliente)}
                setDescricao={setDescricaoCliente}
                descricao={descricaoCliente}
                procedureConsulta="WEBSITE_LIST_GPESSOA_L_ATIVO"
                filtro="CDSPESS"
                erroTexto={clienteErroTexto}
                erro={clienteErro}
                inativo={inativo}
                ajuda={{
                    obrigatorio: true,
                    tituloAjuda: 'Cliente',
                    textoAjuda: 'Informar o código  do cliente ou pesquise o cliente , basta clicar na lupa para pesquisar.',
                    saibaMais: {
                        categoria: 'nfe',
                        campo: 'cliente'
                    }
                }}
            />

            <BuscaForm
                codigo={cfop}
                tabela="CFOP"
                label="CFOP"
                erroTexto={cfopErroTexto}
                erro={cfopErro}
                setCodigoPai={(cfop) => setCfop(cfop)}
                descricao={descricaoCfop}
                setDescricao={setDescricaoCfop}
                procedureConsulta="WEBSITE_LISTAGEM_TCFOP"
                inativo={inativo}
                ajuda={{
                    obrigatorio: true,
                    tituloAjuda: 'CFOP',
                    textoAjuda: '(Código Fiscal de Operações e Prestações) , informar a CFOP para a operação da NF-e , caso haja dúvidas verificar está informação com o contador ou responsável fiscal pela empresa.',
                    saibaMais: {
                        categoria: 'nfe',
                        campo: 'cfop'
                    }
                }}
            />
        </>

    )
}